module.exports = __webpack_public_path__ + "img/3.65a69b11.jpg";